import React from 'react';

const OurPotential = () => {
    return (
        <div className="out-potntial">
        <div className="container">
            <h1 className="l-title">Our Vison & Our Goal</h1>
            <div className="row mt-20">
                <div className="col-md-4 ">
                    <div className="pot-img mt-20">
                        <div className="img-box">
                            <img src="/img/pot11.png" alt="img"/>
                        </div>
                        <div className="pot-box">
                            <h2 className="font-family-medium">Finding critical point of the Business</h2>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 ">
                    <div className="pot-img mt-20">
                        <div className="img-box">
                            <img src="/img/pot12.png" alt="img"/>
                        </div>
                        <div className="pot-box">
                            <h2 className="font-family-medium">Full analytics of clients behaviour</h2>
                        </div>
                    </div>
                </div>
                <div className="col-md-4 ">
                    <div className="pot-img mt-20">
                        <div className="img-box">
                            <img src="/img/pot13.png" alt="img"/>
                        </div>
                        <div className="pot-box">
                            <h2 className="font-family-medium">Chances to develop</h2>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    );
};

export default OurPotential;